export default __webpack_public_path__ + "static/media/NoPlan.1faa796c.svg";